import { useState } from "react";
import { ChevronDown, Eye, GitBranch } from "lucide-react";
import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import { DuckThumb } from "../DuckThumb";
import { CardTitle } from "../CardTitle";
import { statusLabel, fmtDate } from "../DuckCard";
import { DuckDetails } from "./DuckDetails";
import { CoverButton } from "./CoverButton";

// One duck in the list view. A branch sits indented under its original; the chevron opens the details, the picture
// opens the zoom viewer (it never toggles the details). While searching, a family member shown for context is dimmed.
export const DuckRow = ({ c, rowId, branch, ctx }) => {
  const [open, setOpen] = useState(false);
  const context = ctx.q && c.match === false;
  return (
    <li data-testid={`duck-row-${rowId}`} data-match={ctx.q ? String(!context) : undefined} className={`rounded-2xl border bg-card transition-shadow duration-200 hover:shadow-sm ${branch ? "ml-5 sm:ml-10 border-dashed border-border" : "border-border"} ${ctx.q && !context ? "ring-2 ring-primary/70" : ""} ${context ? "opacity-60" : ""}`}>
      <div className="flex items-center gap-2 sm:gap-3 p-2.5">
        <Checkbox checked={ctx.selected.has(c.id)} onCheckedChange={() => ctx.toggle(c)} aria-label={`Select ${c.name || "duck"}`} data-testid={`duck-row-select-${rowId}`} />
        <DuckThumb c={c} buttonTestId={`duck-row-thumb-${rowId}`} buttonClass="rounded-lg shrink-0" size="64" px={40} alt="duck render" testId={`duck-row-tile-${rowId}`} className="h-10 w-10 rounded-lg object-cover border border-border bg-muted/40 shrink-0" />
        <div className="flex-1 min-w-0">
          <CardTitle c={c} i={rowId} prefix="duck-row" actions={ctx.actions} canRename highlight={ctx.q} fallback={`${c.style} ${c.figure === "full" ? "full duck" : "bust"}`} />
          <p className="text-xs text-muted-foreground font-mono2 truncate flex items-center gap-1">
            {branch && <GitBranch className="h-3 w-3 shrink-0" />}
            {branch ? `v${c.version} · ` : ""}
            {statusLabel(c)}
            <span className="hidden sm:inline">{c.created_at ? ` · ${fmtDate(c.created_at)}` : ""}</span>
          </p>
        </div>
        <span data-testid={`duck-row-slot-chip-${rowId}`} className="hidden sm:inline shrink-0 rounded-full bg-muted px-2 py-0.5 text-[11px] font-mono2 text-muted-foreground">{c.slots} slots</span>
        <Button size="sm" variant="secondary" data-testid={`duck-row-open-${rowId}`} onClick={() => ctx.actions.open(c)} className="h-8 rounded-full gap-1 text-xs shrink-0">
          <Eye className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Open</span>
        </Button>
        <button type="button" aria-expanded={open} aria-label={open ? "Hide details" : "Show details"} data-testid={`duck-row-expand-${rowId}`} onClick={() => setOpen((o) => !o)} className="grid place-items-center h-8 w-8 rounded-full hover:bg-muted shrink-0">
          <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
        </button>
      </div>
      {open && <DuckDetails c={c} rowId={rowId} actions={ctx.actions} cover={<CoverButton c={c} ctx={ctx} testId={`duck-row-cover-${rowId}`} />} />}
    </li>
  );
};
